export const EVENT_PRESS_ENTER_TO_ADVANCED_SEARCH = 'press_enter_to_advanced_search';
export const EVENT_PRESS_ESCAPE_IN_COMMAND_PALETTE = 'press_escape_in_command_palette';
export const EVENT_CLICK_OUTSIDE_OF_COMMAND_PALETTE = 'click_outside_of_command_palette';
export const EVENT_PRESS_GREATER_THAN_IN_COMMAND_PALETTE = 'press_greater_than_in_command_palette';
export const EVENT_PRESS_AT_SYMBOL_IN_COMMAND_PALETTE = 'press_at_symbol_in_command_palette';
export const EVENT_PRESS_COLON_IN_COMMAND_PALETTE = 'press_colon_in_command_palette';
export const EVENT_PRESS_FORWARD_SLASH_IN_COMMAND_PALETTE =
  'press_forward_slash_in_command_palette';
export const LABEL_COMMAND_PALETTE = 'command_palette';

export const EVENT_OPEN_FEATURE_LIBRARY_MODAL = 'open_feature_library_modal';
export const EVENT_SEARCH_FEATURES_IN_FEATURE_LIBRARY_MODAL =
  'search_features_in_feature_library_modal';
export const EVENT_CLICK_CATEGORY_FILTER_IN_FEATURE_LIBRARY_MODAL =
  'click_category_filter_in_feature_library_modal';
export const EVENT_PIN_ITEM_IN_FEATURE_LIBRARY_MODAL = 'pin_item_in_feature_library_modal';
export const EVENT_UNPIN_ITEM_IN_FEATURE_LIBRARY_MODAL = 'unpin_item_in_feature_library_modal';
export const EVENT_NAVIGATE_TO_FEATURE_FROM_FEATURE_LIBRARY_MODAL =
  'navigate_to_feature_from_feature_library_modal';
export const EVENT_SEARCH_WITH_GEMINI_IN_FEATURE_LIBRARY_MODAL =
  'search_with_gemini_in_feature_library_modal';
